export default "__VITE_ASSET__C_2sJwji__"